import { Link } from 'react-router-dom'
import LoadingButton from '@mui/lab/LoadingButton'
import { Button, Stack } from '@mui/material'
import { Trans } from '@lingui/macro'

import AddPatientIcon from '@/components/ui/icons/AddPatient'

type PatientsPageActionsProps = {
  canSearchByVitaleCard: boolean
  onAttachPatient: () => void
  onSearchByVitaleCard: () => void
}

export function PatientsPageActions({ canSearchByVitaleCard, onAttachPatient, onSearchByVitaleCard }: PatientsPageActionsProps) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <Button component={Link} disableElevation startIcon={<AddPatientIcon htmlColor="#FFF" />} to="/patients/create" variant="contained">
        <Trans>New patient</Trans>
      </Button>
      <Button component={Link} to="/patients/merge" variant="outlined">
        <Trans>Merge patients</Trans>
      </Button>
      <Button disableElevation variant="outlined" onClick={onAttachPatient}>
        <Trans>Attach Patient</Trans>
      </Button>
      {canSearchByVitaleCard && (
        <LoadingButton onClick={onSearchByVitaleCard} variant="outlined">
          <Trans>Search by vitale card</Trans>
        </LoadingButton>
      )}
    </Stack>
  )
}
